document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.querySelector('[data-mobile-drawer]');
  document.querySelectorAll('[data-menu-toggle]').forEach(button=>button.addEventListener('click',()=>{
    const open=drawer.classList.toggle('open');
    document.body.classList.toggle('menu-open',open);
    button.setAttribute('aria-expanded',open?'true':'false');
  }));
  document.querySelectorAll('[data-video-card]').forEach(card=>{
    const video=card.querySelector('video');
    if(!video)return;
    const play=()=>{card.classList.add('video-active');video.play().catch(()=>{});};
    const stop=()=>{card.classList.remove('video-active');video.pause();video.currentTime=0;};
    card.addEventListener('mouseenter',play);card.addEventListener('mouseleave',stop);
    card.addEventListener('touchstart',()=>card.classList.contains('video-active')?stop():play(),{passive:true});
  });
  const estimate=document.querySelector('[data-delivery-estimate]');
  if(estimate){
    const addBusinessDays=(date,days)=>{const result=new Date(date);let added=0;while(added<days){result.setDate(result.getDate()+1);if(result.getDay()!==0&&result.getDay()!==6)added++;}return result;};
    const min=Number(estimate.dataset.productionMin||10),max=Number(estimate.dataset.productionMax||18);
    const start=addBusinessDays(new Date(),min),end=addBusinessDays(new Date(),max);
    const format=d=>d.toLocaleDateString('en-US',{month:'long',day:'numeric'});
    estimate.querySelector('span').textContent=`${format(start)} – ${format(end)}`;
  }
});
